import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, MapPin } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Spinner, EmptyState } from "@/components/shared";

export default function ProjectDetailPage() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => { api.get(`/projects/${slug}`).then((r) => setP(r.data)).catch(() => setNotFound(true)); }, [slug]);

  if (notFound) return <div className="propora-container py-16"><EmptyState title="Project not found" /></div>;
  if (!p) return <Spinner />;

  return (
    <div className="propora-container py-10" data-testid="project-detail-page">
      <Link to="/properties" className="inline-flex items-center gap-1.5 text-sm text-[#4A5568] hover:text-[#007F83] mb-6"><ArrowLeft size={16} /> Back</Link>
      <div className="rounded-3xl overflow-hidden h-72 bg-[#E8F5F1] shadow-soft"><img src={p.image} alt={p.name} className="w-full h-full object-cover" /></div>
      <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display font-extrabold text-4xl text-[#0B1733]">{p.name}</h1>
          <p className="text-[#4A5568] inline-flex items-center gap-1 mt-2"><MapPin size={15} /> {p.location} · {p.status}</p>
        </div>
        <Link to={`/post-a-job`}><Button className="rounded-full bg-[#007F83] hover:bg-[#006B70] text-white" data-testid="project-post-job-btn">Post a job for this building</Button></Link>
      </div>
      <p className="mt-5 text-[#4A5568] max-w-2xl">{p.description}</p>

      {p.properties?.length > 0 && (
        <>
          <h2 className="font-display font-bold text-2xl text-[#0B1733] mt-10 mb-4">Listings in this project</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {p.properties.map((pr) => (
              <Link key={pr.id} to={`/properties/${pr.slug}`} className="bg-white rounded-2xl border border-[#E3E8E8] overflow-hidden card-lift">
                <div className="h-44 bg-[#E8F5F1]"><img src={pr.image} alt={pr.name} className="w-full h-full object-cover" /></div>
                <div className="p-4"><h3 className="font-display font-bold text-[#0B1733]">{pr.name}</h3><p className="text-sm text-[#007F83] font-semibold mt-1">{pr.asking_price}</p></div>
              </Link>
            ))}
          </div>
        </>
      )}

      {p.discussions?.length > 0 && (
        <>
          <h2 className="font-display font-bold text-2xl text-[#0B1733] mt-10 mb-4">Community discussions</h2>
          <div className="space-y-3">
            {p.discussions.map((d) => (
              <Link key={d.id} to={`/community/posts/${d.id}`} className="block bg-white rounded-2xl border border-[#E3E8E8] p-5 card-lift">
                <h3 className="font-display font-bold text-[#0B1733]">{d.title}</h3>
                <p className="text-sm text-[#4A5568] mt-1 line-clamp-2">{d.body}</p>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
